import { TRANSACTION_ORDER_TYPE_LABELS } from "creso-core/constants";
import { TransactionOrder } from "creso-core/types";
import capitalize from "lodash/capitalize";
import { cn } from "web-design-system";

export function OrderActionType({ order }: { order: TransactionOrder }) {
  return (
    <span
      className={cn(
        "text-xs font-medium",
        order.action_type === "CANCEL" && "text-destructive"
      )}
    >
      {order.action_type !== "CREATE" ? capitalize(order.action_type) : ""}{" "}
      {TRANSACTION_ORDER_TYPE_LABELS[order.type]}
    </span>
  );
}
